import DealsTabs from './DealsTabs';

export default DealsTabs;
